export default "__VITE_ASSET__Dd_CkiF___$_?url__"